import React from 'react';

import styled from '@emotion/styled';

import DupontTooltip from '../DupontTooltip';

export interface DupontIconBtnProps {
  id?: string;
  name?: string;
  active?: boolean;
  tooltip?: string;
  disabled?: boolean;
  onClick: any;
  customClass?: string;
  children: any;
  className?: string;
}

const StyledDiv = styled('div')`
  .dupont-icon-btn,
  .dupont-icon-btn-remove {
    padding: 0px;
    border: none;
    background: transparent;
    border-radius: 2px;
    cursor: pointer;

    &:disabled {
      color: var(--color-medium-grey);
      background-color: var(--color-light-grey);
      cursor: not-allowed;
      border: none;
    }

    &--active {
      background-color: var(--color-primary);
      border: 0.5px solid var(--color-primary);
    }
  }

  .dupont-icon-btn {
    height: 32px;
    width: 32px;
  }
`;

const DupontIconButton: React.FC<DupontIconBtnProps> = props => {
  let { id, name, active, tooltip, disabled, onClick, customClass, children, className } = props;
  customClass = customClass || '';
  const type = disabled ? 'disabled' : 'primary';
  const btnId = id || name || 'dupont-icon-btn';

  const getBtnClass = () => {
    let btnClasses = 'dupont-icon-btn';
    btnClasses = active ? `${btnClasses} dupont-icon-btn--active` : btnClasses;
    btnClasses = customClass ? `${btnClasses} ${customClass}` : btnClasses;
    return btnClasses;
  };

  return (
    <DupontTooltip type={type} title={tooltip || ''} className={className}>
      <StyledDiv className={className}>
        <button id={btnId} name={name} className={getBtnClass()} disabled={disabled} onClick={onClick}>
          {children}
        </button>
      </StyledDiv>
    </DupontTooltip>
  );
};

export default DupontIconButton;
